"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = RadioButtons;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_sanofi/cssConstants.js"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _targetCss$colors$for, _targetCss$colors, _targetCss$colors2, _targetCss$colors$for2, _targetCss$colors3, _targetCss$colors4;

var StyledRadio = (0, _styles.withStyles)({
  root: {
    color: (_targetCss$colors$for = (_targetCss$colors = _cssConstants["default"].colors) === null || _targetCss$colors === void 0 ? void 0 : _targetCss$colors.formRadioButtons) !== null && _targetCss$colors$for !== void 0 ? _targetCss$colors$for : (_targetCss$colors2 = _cssConstants["default"].colors) === null || _targetCss$colors2 === void 0 ? void 0 : _targetCss$colors2.buttonBackground,
    '&$checked': {
      color: "".concat((_targetCss$colors$for2 = (_targetCss$colors3 = _cssConstants["default"].colors) === null || _targetCss$colors3 === void 0 ? void 0 : _targetCss$colors3.formRadioButtons) !== null && _targetCss$colors$for2 !== void 0 ? _targetCss$colors$for2 : (_targetCss$colors4 = _cssConstants["default"].colors) === null || _targetCss$colors4 === void 0 ? void 0 : _targetCss$colors4.buttonBackground, " !important")
    }
  }
})(_Radio["default"]);

function RadioButtons(props) {
  var _props$block = props.block,
      content = _props$block.content,
      direction = _props$block.direction,
      _props$block$isPrecon = _props$block.isPreconditionData,
      isPreconditionData = _props$block$isPrecon === void 0 ? false : _props$block$isPrecon,
      parentPath = props.parentPath,
      _props$isAutoSave = props.isAutoSave,
      isAutoSave = _props$isAutoSave === void 0 ? false : _props$isAutoSave,
      _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function () {
    return null;
  } : _props$onSubmit,
      isLogInArray = props.isLogInArray;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', ''),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      value = _useDataStore2[0],
      setValue = _useDataStore2[1];

  var _useDataStore3 = (0, _GenericStore.useDataStore)(parentPath + '/isValid', true),
      _useDataStore4 = (0, _slicedToArray2["default"])(_useDataStore3, 2),
      isValid = _useDataStore4[0],
      setIsValid = _useDataStore4[1];

  var _useDataStore5 = (0, _GenericStore.useDataStore)(parentPath + '/errorMessage', true),
      _useDataStore6 = (0, _slicedToArray2["default"])(_useDataStore5, 2),
      errorMessage = _useDataStore6[0],
      setErrorMessage = _useDataStore6[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    setIsValid(true);
    if (isAutoSave && !isLogInArray) onSubmit();
  };

  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    component: "fieldset",
    error: !isValid,
    className: 'ctnRadioButtons',
    style: {
      padding: '10px 0'
    }
  }, /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    "aria-label": "gender",
    name: "gender1",
    value: value,
    onChange: handleChange,
    row: direction === 'row' || false
  }, content.map(function (radio, index) {
    return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      key: "radio_".concat(index),
      className: 'ctnRadioButtonsItem',
      value: radio.value,
      control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
        color: 'default'
      }),
      label: radio.label
    });
  })), /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], null, !isValid && t(errorMessage)));
}